import { render, staticRenderFns } from "./landPageAdd.vue?vue&type=template&id=9bccb216&scoped=true"
import script from "./landPageAdd.vue?vue&type=script&lang=js"
export * from "./landPageAdd.vue?vue&type=script&lang=js"
import style0 from "./landPageAdd.vue?vue&type=style&index=0&id=9bccb216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bccb216",
  null
  
)

export default component.exports